module.exports = __webpack_public_path__ + "assets/img/立即开通@2x.969bb2dc.png";